// EO-1891 / EO-1892 — Black Friday offer: an Action Centre v2 card with this
// theme, plus the top strip and home-page pop-up that point at it. Every
// discount and date shown comes from the card's promo_object_dr.
export const BLACK_FRIDAY_THEME = "black_friday";

// Navigation state key: Home opens this recommendation's Create Promo panel
// (set by the strip on pages other than Home).
export const BLACK_FRIDAY_OPEN_STATE_KEY = "openBlackFridayRecommendationId";

// Pop-up shows once per session (sessionStorage) per user, across properties.
export const BLACK_FRIDAY_MODAL_SEEN_KEY = "bfOfferModalSeen";

export const BLACK_FRIDAY_COPY = Object.freeze({
  stripLead: "Black Friday",
  stripMiddle: "buyers are shopping.",
  stripTail: "Get on their shelf.",
  stripSubline: (date) => `Publish your offer by ${date}`,
  stripCta: "Join Black Friday",
  modalTitleAccent: "Black Friday is coming.",
  modalTitleTail: "Make sure buyers find you",
  modalBody:
    "Buyers across the Exchange are looking for hotels to feature this Black Friday.",
  modalBodyAccent: "Be one.",
  modalCta: "Review & Join",
  cardPill: "Black Friday",
  cardDiscountLabel: "Discount",
  cardWindowLabel: "Booking window",
  maybeLater: "Maybe Later",
  close: "Close",
});

// Heap: data-heap-id values (autocaptured) and the impressions that need an
// explicit event, per component as EO-1892 asks.
export const BLACK_FRIDAY_HEAP = Object.freeze({
  stripReviewId: "black-friday-strip-review-offer",
  modalReviewId: "black-friday-modal-review-offer",
  modalCloseId: "black-friday-modal-close",
  stripShown: "Black Friday Strip Shown",
  modalShown: "Black Friday Modal Shown",
  modalDismissed: "Black Friday Modal Dismissed",
});
